import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=57447e84&scoped=true&"
import script from "./addClass.vue?vue&type=script&lang=js&"
export * from "./addClass.vue?vue&type=script&lang=js&"
import style0 from "./addClass.vue?vue&type=style&index=0&id=57447e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57447e84",
  null
  
)

export default component.exports